import { useTranslation } from "@redotech/redo-i18n";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";
import { formatOldSettingsShutoffDate } from "./old-settings-shutoff";

export const SwitchBackModal = memo(function SwitchBackModal({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  return (
    <RedoModal
      isOpen={open}
      modalSize="sm"
      onModalCloseRequested={onCancel}
      primaryButton={{
        text: t("Switch back"),
        onClick: onConfirm,
        size: "sm",
        dataTrackId: "merchant.settings.returns.switch-back.confirm",
      }}
      secondaryButton={{
        text: t("Cancel"),
        onClick: onCancel,
        size: "sm",
        dataTrackId: "merchant.settings.returns.switch-back.cancel",
      }}
      subtitle={t(
        "You'll return to the previous Returns settings experience and won't be able to switch back. The new experience will become permanent for everyone on {{date}}.",
        { date: formatOldSettingsShutoffDate() },
      )}
      title={t("Switch back to previous version")}
    />
  );
});
